import * as React from "react";
import { Layout } from "antd";
const { Content, Footer } = Layout;

import NavTop from "../NavTop";

export interface Props {
  children?: React.ReactNode;
}

export interface State {}

export default class MainLayout extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  render() {
    const padding = "10%";
    return (
      <Layout style={{ minHeight: "100vh" }}>
        <NavTop padding={padding} />
        <Content style={{ paddingLeft: padding, paddingRight: padding }}>
          {this.props.children}
        </Content>
        <Footer style={{ textAlign: "center" }}>
          Jugend Großweikersdorf ©2018
        </Footer>
      </Layout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/MainLayout/MainLayout.tsx